// TrendLine.jsx — Task 11 artifact slot (DEC-11-D). A dependency-free inline-SVG polyline (no chart
// lib → no CSP/pipeline risk). Props: { label?, points:[{label, value}] }.
import React from "react"

export default function TrendLine({ label, points }) {
  if (!Array.isArray(points) || points.length === 0) return null
  const W = 680
  const H = 200
  const L = 8
  const R = 8
  const T = 22
  const B = 28
  const values = points.map((p) => (typeof p.value === "number" ? p.value : 0))
  const max = Math.max(1, ...values) * 1.14
  const n = points.length
  const x = (i) => L + ((W - L - R) / Math.max(1, n - 1)) * i
  const y = (v) => T + (H - T - B) * (1 - v / max)
  const line = values.map((v, i) => `${x(i)},${y(v)}`).join(" ")

  return (
    <div className="afq-card" data-slot="trend_line">
      {label ? <div className="afq-card-h"><h2>{label}</h2></div> : null}
      <div className="afq-chartbox">
        <svg viewBox={`0 0 ${W} ${H}`} role="img" aria-label={label || "Trend"}>
          <polyline
            points={line}
            fill="none"
            stroke="var(--vs-action, #5349E5)"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          {values.map((v, i) => (
            <circle key={i} cx={x(i)} cy={y(v)} r="4" fill="#fff" stroke="var(--vs-action, #5349E5)" strokeWidth="2.5">
              <title>{points[i].label}: {v}</title>
            </circle>
          ))}
          {points.map((p, i) => (
            <text key={i} x={x(i)} y={H - 8} textAnchor="middle" fontSize="11" fontWeight="600" fill="#94A3B8">
              {p.label}
            </text>
          ))}
        </svg>
      </div>
    </div>
  )
}
